<div class="navbar-container" *ngIf="!isLogin && !isForgotPassword && !isMFA && !isSSO && !isDOBCheck">
	<nav class="navbar navbar-expand-lg navbar-csc">
		<img [routerLink]="['/login']" [src]="imageLogo" class="header-img" onerror="this.onerror=null;this.src='menu_logo_dark.png';" />
    	<span class="logo-text">{{logoName}}</span>


    <div class="nk-header-tools" *ngIf="getRouteUrl() != '/mfaLogin'">
      <ul class="nk-quick-nav" *ngIf="userData">
        <li class="dropdown user-dropdown">
          <a href="#" class="dropdown-toggle" data-bs-toggle="dropdown" [isOpen]="status.isopen" (isOpenChange)="change($event)">
            <div class="user-toggle ">
              <div class="csc-user-color user-avatar">
                <em class="icon ni ni-user-alt"></em>
              </div>
            </div>
          </a>

          <div class="dropdown-menu dropdown-menu-md dropdown-menu-end">
            <div class="dropdown-inner user-card-wrap bg-lighter d-none d-md-block">
              <div class="user-card">
                <div class="user-avatar">
                  <em class="icon ni ni-user-alt"></em>
                </div>
                <div class="user-info">
                  <span class="lead-text">{{user}}</span>
                </div>
              </div>
            </div>

            <div class="dropdown-inner">
              <ul class="link-list">
                <li>
                  <a routerLink="/" [routerLinkActiveOptions]="{exact: true}" [routerLinkActive]="'active'" [ngClass]="{ 'active': isDashboardRoute()}" class="csc-navbar-item"
                     href="#"  *ngIf="getRouteUrl() != '/mfaLogin'"><em class="icon ni ni-home"></em><span>{{'Dashboard' | translate}}</span>
                  </a>
                </li>
                <li >
                  <a routerLink="/user/edit-notifications" href="#" class="csc-navbar-item">
                    <em class="icon ni ni-note-add"></em><span>{{'Subscriptions' | translate}}</span>
                  </a>
                </li>

                <li *ngIf="isBlogsAvailable">
                  <a [routerLink]="['/io-news']" [routerLinkActive]="'active'" href="#" class="csc-navbar-item">
                    <em class="icon ni ni-chat-circle"></em><span>{{'Blogs' | translate}}</span>
                  </a>
                </li>
                <li *ngIf="isHelpLineAvailable">
                  <a [routerLink]="['/help-line']" [routerLinkActive]="'active'" href="#" class="csc-navbar-item">
                    <em class="icon ni ni-call"></em><span>{{'Blogs' | translate}}</span>
                  </a>
                </li>
                <li  *ngIf="isLocalResourcesAvailable">
                  <a [routerLink]="['/local-resources']" [routerLinkActive]="'active'" href="#" class="csc-navbar-item">
                    <em class="icon ni ni-bag"></em><span>{{'Local Resources' | translate}}</span>
                  </a>
                </li>
              </ul>
            </div>
            <div class="dropdown-inner">
              <ul class="link-list">
                <li>
                    <a href="/logout" onclick="javascript:void(0)" (click)="logout()" class="csc-navbar-item"><em class="icon ni ni-signout"></em><span>{{'Logout' | translate}}</span></a>
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul><!-- /.ace-nav -->
    </div>

	</nav>
</div>

<div class="alert-container" *ngFor="let alert of alerts">
	<alert dismissible="true" [type]="alert.type">
		<div class="alert-content">
			<i *ngIf="alert.type==='success'" class="ni ni-check-bold" aria-hidden="true"></i>
			<i *ngIf="alert.type==='danger'" class="bi bi-exclamation-triangle" aria-hidden="true"></i>
			<span [innerHtml]="alert.msg"></span>
		</div>
	</alert>
</div>
